export const FEATURE_FLAGS = {
  OPERATIONAL_MEDPREV_WEB_APP_LEVEL_TWO: 'operational-medprev-web-app-level-two',
} as const;

export type FeatureFlagKey = typeof FEATURE_FLAGS[keyof typeof FEATURE_FLAGS];

export const FEATURE_FLAG_DEFAULTS: Record<FeatureFlagKey, boolean> = {
  [FEATURE_FLAGS.OPERATIONAL_MEDPREV_WEB_APP_LEVEL_TWO]: false,
} as const;
